import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import InternalNotesBanner from "../InternalNotesBanner";
import NonRKPayEstimateActionsBanner from "../NonRKPayEstimateActionsBanner";

const NonRKPayStickyBanner = ({ nonRKPayInvoiceDetailHook, router, invoiceSent, setInvoiceSent }) => {
    const navbarRef = useRef(null);
    const {
        nonrkpayDetailPrepayEnhancementsEnabled,
        internalNotes,
        showInternalNotes,
    } = nonRKPayInvoiceDetailHook;

        const onScroll = () => {
        const sticky = 40;

        if (window.scrollY >= sticky) {
            navbarRef.current.classList.add("sticky-banner");
        } else {
            navbarRef.current.classList.remove("sticky-banner");
        }
    };

    useEffect(() => {
        onScroll();

        document.addEventListener("scroll", onScroll);

        return () => {
            document.removeEventListener("scroll", onScroll);
        };
    }, []);

    return (
        <div
            ref={navbarRef}
            className="hidden-print"
        >
            {/* Estimate actions banner */}
            <If condition={nonrkpayDetailPrepayEnhancementsEnabled}>
                <NonRKPayEstimateActionsBanner
                    nonRKPayInvoiceDetailHook={nonRKPayInvoiceDetailHook}
                    router={router}
                    invoiceSent={invoiceSent}
                    setInvoiceSent={setInvoiceSent}
                />
            </If>
            {/* Internal notes banner */}
            <If condition={internalNotes && showInternalNotes}>
                <InternalNotesBanner
                    nonRKPayInvoiceDetailHook={nonRKPayInvoiceDetailHook}
                />
            </If>
        </div>
    );
};

NonRKPayStickyBanner.propTypes = {
    nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    invoiceSent: PropTypes.bool.isRequired,
    setInvoiceSent: PropTypes.func.isRequired,
};

export default NonRKPayStickyBanner;
